import { render } from "./SlidePreview.vue?vue&type=template&id=3b5aa9eb&scoped=true"
import script from "./SlidePreview.vue?vue&type=script&lang=js"
export * from "./SlidePreview.vue?vue&type=script&lang=js"

import "./SlidePreview.vue?vue&type=style&index=0&id=3b5aa9eb&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5aa9eb"]])

export default __exports__